export function addToCartDataLayer(product, productVariant = null, listname = null, position = null) {
    if (!product) {
        return;
    }

    let { authors, category, parent_category, year_of_publication, number_of_pages, binding, language, publishing_house } = getProductInfo(product);

    try {
        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object
        window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                currency: "EUR",
                value: productVariant ? productVariant.final_price : product.final_price,
                items: [{
                    item_id: product.id,
                    item_name: product.title,
                    discount: productVariant ? Number(productVariant.nominal_discount_value) : Number(product.nominal_discount_value),
                    item_brand: publishing_house,
                    item_category: category,
                    item_category2: product.product_state ? product.product_state.title : null,
                    item_category3: product.product_type ? product.product_type.title : 'bez zaradenia',
                    item_category4: authors,
                    item_category5: product.average_rating,
                    item_category6: year_of_publication,
                    item_category7: number_of_pages,
                    item_category8: binding,
                    item_category9: language,
                    item_list_id: position ?? null,
                    item_list_name: listname ?? null,
                    item_variant: parent_category ,
                    price: productVariant ? productVariant.price_without_tax : product.price_without_tax,
                    quantity: 1
                }]
            }
        });
    } catch (error) {
        console.error('Error pushing to dataLayer:', error);
    }
}

export function purchaseDataLayer(order) {
    if (!order) {
        return;
    }

    try {
        let items = [];

        order.order_products.forEach(orderProduct => {
            let { authors, category, parent_category, year_of_publication, number_of_pages, binding, language, publishing_house } = getProductInfo(orderProduct.product);

            items.push({
                item_id: orderProduct.product.id,
                item_name: orderProduct.product.title,
                item_brand: publishing_house,
                item_category: category,
                item_category2: orderProduct.product.product_state ? orderProduct.product.product_state.title : null,
                item_category3: orderProduct.product.product_type ? orderProduct.product.product_type.title : 'bez zaradenia',
                item_category4: authors,
                item_category5: orderProduct.product.average_rating,
                item_category6: year_of_publication,
                item_category7: number_of_pages,
                item_category8: binding,
                item_category9: language,
                item_list_id: null,
                item_list_name: null,
                item_variant: parent_category,
                price: orderProduct.final_single_product_price_with_tax,
                quantity: orderProduct.product_quantity,
                discount: Number(orderProduct.discount_value)
            });
        });

        if (order.price_rounding) {
            items.push({
                item_id: 'podpora',
                item_name: 'podpora',
                item_brand: 'postoj',
                price: Number(order.price_rounding),
                quantity: 1
            });

        }

        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object
        window.dataLayer.push({
            event: "purchase",
            ecommerce: {
                transaction_id: order.id,
                value: order.final_price_with_tax,
                tax: order.final_price_and_tax ? order.final_price_and_tax.tax : null,
                shipping: Number(order.delivery_price_with_tax),
                // shipping_method: order.delivery_method ? order.delivery_method.title : null,
                payment_fee: Number(order.payment_price_with_tax),
                // payment_method: order.payment_method ? order.payment_method.title : null,
                // rounding: Number(order.price_rounding),
                currency: "EUR",
                coupon: order.discount ? order.discount.code : null,
                items: items
            }
        });
    } catch (error) {
        console.error('Error pushing to dataLayer:', error);
    }
}

export function productDetailDatalayer(product) {
    if (!product) {
        return;
    }

    try {
        let {authors, category, parent_category, year_of_publication, number_of_pages, binding, language, publishing_house} = getProductInfo(product);

        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object
        window.dataLayer.push({
            event: "view_item",
            ecommerce: {
                currency: "EUR",
                value: product.final_price,
                items: [{
                    item_id: product.id,
                    item_name: product.title,
                    item_brand: publishing_house,
                    item_category: category,
                    item_category2: product.product_state ? product.product_state.title : null,
                    item_category3: product.product_type ? product.product_type.title : 'bez zaradenia',
                    item_category4: authors,
                    item_category5: product.average_rating,
                    item_category6: year_of_publication,
                    item_category7: number_of_pages,
                    item_category8: binding,
                    item_category9: language,
                    item_variant: parent_category,
                    price: product.price_without_tax,
                    discount: Number(product.nominal_discount_value),
                    quantity: 1
                }]
            }
        });
    } catch (error) {
        console.error('Error pushing to dataLayer:', error);
    }
}

export function beginCheckoutDataLayer(cart) {
    if (!cart) {
        return;
    }

    try {
        let items = [];

        cart.cart_products.forEach(cartProduct => {
            let {authors, category, parent_category, year_of_publication, number_of_pages, binding, language, publishing_house} = getProductInfo(cartProduct.product);

            items
                .push({
                    item_id: cartProduct.product.id,
                    item_name: cartProduct.product.title,
                    item_brand: publishing_house,
                    item_category: category,
                    item_category2: cartProduct.product.product_state ? cartProduct.product.product_state.title : null,
                    item_category3: cartProduct.product.product_type ? cartProduct.product.product_type.title : 'bez zaradenia',
                    item_category4: authors,
                    item_category5: cartProduct.product.average_rating,
                    item_category6: year_of_publication,
                    item_category7: number_of_pages,
                    item_category8: binding,
                    item_category9: language,
                    item_variant: parent_category,
                    price: Number(cartProduct.price_with_tax),
                    discount: Number(cartProduct.discount_value),
                    quantity: cartProduct.product_quantity
                });
        });

        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object
        window.dataLayer.push({
            event: "begin_checkout",
            ecommerce: {
                currency: "EUR",
                value: cart.final_price,
                coupon: cart.discount ? cart.discount.code : null,
                items: items
            }
        });
    } catch (error) {
        console.error('Error pushing to dataLayer:', error);
    }
}

export function removeFromCartDataLayer(product, productVariant = null, quantity = 1) {
    if (!product) {
        return;
    }


    try {
        let {authors, category, parent_category, year_of_publication, number_of_pages, binding, language, publishing_house} = getProductInfo(product);

        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object
        window.dataLayer.push({
            event: "remove_from_cart",
            ecommerce: {
                currency: "EUR",
                value: productVariant ? productVariant.final_price : product.final_price,
                items: [{
                    item_id: product.id,
                    item_name: product.title,
                    discount: productVariant ? Number(productVariant.nominal_discount_value) : Number(product.nominal_discount_value),
                    item_brand: publishing_house,
                    item_category: category,
                    item_category2: product.product_state ? product.product_state.title : null,
                    item_category3: product.product_type ? product.product_type.title : 'bez zaradenia',
                    item_category4: authors,
                    item_category5: product.average_rating,
                    item_category6: year_of_publication,
                    item_category7: number_of_pages,
                    item_category8: binding,
                    item_category9: language,
                    item_variant: parent_category,
                    price: productVariant ? productVariant.price_without_tax : product.price_without_tax,
                    quantity: quantity
                }]
            }
        });
    } catch (error) {
        console.error('Error pushing to dataLayer:', error);
    }
}

export function viewCartDataLayer(cart) {
    if (!cart) {
        return;
    }

    try {
        let items = [];

        cart.cart_products.forEach(cartProduct => {
            let {authors, category, parent_category, year_of_publication, number_of_pages, binding, language, publishing_house} = getProductInfo(cartProduct.product);

            items.push({
                item_id: cartProduct.product.id,
                item_name: cartProduct.product.title,
                item_brand: publishing_house,
                item_category: category,
                item_category2: cartProduct.product.product_state ? cartProduct.product.product_state.title : null,
                item_category3: cartProduct.product.product_type ? cartProduct.product.product_type.title : 'bez zaradenia',
                item_category4: authors,
                item_category5: cartProduct.product.average_rating,
                item_category6: year_of_publication,
                item_category7: number_of_pages,
                item_category8: binding,
                item_category9: language,
                item_variant: parent_category,
                price: Number(cartProduct.price_with_tax),
                discount: Number(cartProduct.discount_value),
                quantity: cartProduct.product_quantity
            });
        });

        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object
        window.dataLayer.push({
            event: "view_cart",
            ecommerce: {
                currency: "EUR",
                value: cart.final_price,
                items: items
            }
        });
    }
    catch (error) {
        console.error('Error pushing to dataLayer:', error);
    }
}

export function trackProductClick(product, list, position) {
    if (!product) {
        return;
    }


    let items = [];

    try {
        let {authors, category, parent_category, year_of_publication, number_of_pages, binding, language, publishing_house} = getProductInfo(product);

        items.push({
            item_id: product.id,
            item_name: product.title,
            discount: Number(product.nominal_discount_value),
            item_brand: publishing_house,
            item_category: category,
            item_category2: product.product_state ? product.product_state.title : null,
            item_category3: product.product_type ? product.product_type.title : 'bez zaradenia',
            item_category4: authors,
            item_category5: product.average_rating,
            item_category6: year_of_publication,
            item_category7: number_of_pages,
            item_category8: binding,
            item_category9: language,
            item_variant: parent_category,
            item_list_id: position ?? null,
            item_list_name: list ?? null,
            price: product.price_without_tax,
            quantity: 1
        });

        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object
        window.dataLayer.push({
            event: "select_item",
            ecommerce: {
                currency: "EUR",
                value: product.final_price,
                items
            }
        });
    }
    catch (error) {
        console.error('Error pushing to dataLayer:', error);
    }
}

const AnalyticScripts = {
    addToCartDataLayer,
    purchaseDataLayer,
    productDetailDatalayer,
    beginCheckoutDataLayer,
    removeFromCartDataLayer,
    viewCartDataLayer,
    trackProductClick
};
export default AnalyticScripts;

window.AnalyticScripts = AnalyticScripts;

function getProductInfo(product) {
    let authors, category, parent_category, year_of_publication, number_of_pages, binding, language, publishing_house;

    if (product.product_type_id === 3 || product.product_type_id === 4) {
        // Take values from product.bundles[0] if product_type_id is 3 or 4
        authors = product.bundles[0].authors ? product.bundles[0].authors.map(author => author.name).join(", ") : null;
        category = product.bundles[0].category ? product.bundles[0].category.title : null;
        parent_category = product.bundles[0].category && product.bundles[0].category.parent ? product.bundles[0].category.parent.title : null;
        year_of_publication = product.bundles[0].product_detail ? product.bundles[0].product_detail.year_of_publication : null;
        number_of_pages = product.bundles[0].product_detail ? product.bundles[0].product_detail.number_of_pages : null;
        binding = product.bundles[0].product_detail ? product.bundles[0].product_detail.binding : null;
        language = product.bundles[0].product_detail ? product.bundles[0].product_detail.language : null;
        publishing_house = product.bundles[0].publishing_house ? product.bundles[0].publishing_house.title : null;
    } else if (product.product_type_id === 2) {
        // If product_type is 2, set all info to "multiple_different_values"
        authors = 'multiple_different_values';
        category = 'multiple_different_values';
        year_of_publication = 'multiple_different_values';
        number_of_pages = 'multiple_different_values';
        binding = 'multiple_different_values';
        language = 'multiple_different_values';
        publishing_house = 'multiple_different_values';
    } else {
        // Default values for other product types
        authors = product.authors ? product.authors.map(author => author.name).join(", ") : null;
        category = product.category ? product.category.title : null;
        parent_category = product.category && product.category.parent ? product.category.parent.title : null;
        year_of_publication = product.product_detail ? product.product_detail.year_of_publication : null;
        number_of_pages = product.product_detail ? product.product_detail.number_of_pages : null;
        binding = product.product_detail ? product.product_detail.binding : null;
        language = product.product_detail ? product.product_detail.language : null;
        publishing_house = product.publishing_house ? product.publishing_house.title : null;
    }



    return {
        authors,
        category,
        parent_category,
        year_of_publication,
        number_of_pages,
        binding,
        language,
        publishing_house
    };
}

$(document).ready(function () {
    // Handle product detail data layer
    const viewDetailDataEl = document.getElementById('product-detail-dataLayer');
    if (viewDetailDataEl && viewDetailDataEl.dataset.productInfo) {
        try {
            const product = JSON.parse(viewDetailDataEl.dataset.productInfo);
            AnalyticScripts.productDetailDatalayer(product);
        } catch (error) {
            console.error('Error parsing product detail data:', error);
        }
    }

    // Handle purchase data layer
    const purchaseDataEl = document.getElementById('order-data-for-dataLayer');
    if (purchaseDataEl && purchaseDataEl.dataset.order) {
        try {
            const order = JSON.parse(purchaseDataEl.dataset.order);
            AnalyticScripts.purchaseDataLayer(order);
        } catch (error) {
            console.error('Error parsing order data:', error);
        }
    }
});
